import { useEffect, useRef } from "react";

let ytApiPromise;
function loadYT() {
  if (ytApiPromise) return ytApiPromise;
  ytApiPromise = new Promise((resolve) => {
    if (window.YT && window.YT.Player) return resolve(window.YT);
    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    const prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      if (prev) prev();
      resolve(window.YT);
    };
    document.head.appendChild(tag);
  });
  return ytApiPromise;
}

export default function YouTubeBackground({ videoId, start = 0, end = 10 }) {
  const hostRef = useRef(null);

  useEffect(() => {
    let destroyed = false;
    let interval;
    let player;
    loadYT().then((YT) => {
      if (destroyed || !hostRef.current) return;
      const el = document.createElement("div");
      hostRef.current.appendChild(el);
      player = new YT.Player(el, {
        videoId,
        host: "https://www.youtube-nocookie.com",
        playerVars: {
          autoplay: 1, mute: 1, controls: 0, rel: 0, fs: 0,
          modestbranding: 1, playsinline: 1, disablekb: 1,
          iv_load_policy: 3, start, loop: 1, playlist: videoId,
          origin: typeof window !== "undefined" ? window.location.origin : undefined,
        },
        events: {
          onReady: (e) => { e.target.mute(); e.target.playVideo(); },
          onStateChange: (e) => {
            if (e.data === YT.PlayerState.PLAYING) {
              if (hostRef.current) hostRef.current.classList.add("yt-visible");
              clearInterval(interval);
              interval = setInterval(() => {
                try {
                  if (e.target.getCurrentTime() >= end) e.target.seekTo(start, true);
                } catch (err) { /* noop */ }
              }, 250);
            }
          },
          onError: () => { if (hostRef.current) hostRef.current.classList.remove("yt-visible"); },
        },
      });
    });
    return () => {
      destroyed = true;
      clearInterval(interval);
      try { player && player.destroy(); } catch (e) { /* noop */ }
    };
  }, [videoId, start, end]);

  return <div ref={hostRef} className="yt-bg" aria-hidden="true" />;
}
